function initializeJournal(root = document) {
  root.querySelectorAll('.mec-article').forEach((article) => {
    const toc = article.querySelector('[data-journal-toc]');
    const content = article.querySelector('.article-template__content');
    if (!toc || !content || toc.dataset.ready) return;
    const title = article.querySelector('h1').textContent.trim().replace(/\s+/g, ' ');
    const headings = [...content.querySelectorAll('h2, h3')].filter((heading) => {
      const text = heading.textContent.trim().replace(/\s+/g, ' ');
      return text && text !== title;
    });
    if (headings.length < 2) return;
    const list = toc.querySelector('ol');
    headings.forEach((heading, index) => {
      if (!heading.id) {
        let id = `journal-heading-${index + 1}`;
        while (document.getElementById(id)) id += '-section';
        heading.id = id;
      }
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      item.append(link);
      list.append(item);
    });
    toc.hidden = false;
    toc.dataset.ready = 'true';
    const toggle = toc.querySelector('button');
    const navigation = toc.querySelector('nav');
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.querySelector('span').textContent = expanded ? '−' : '+';
      navigation.hidden = !expanded;
    });
  });
}
initializeJournal();
document.addEventListener('shopify:section:load', (event) => initializeJournal(event.target));
